import BaseDataObject from './BaseDataObject';

export default class BetKey extends BaseDataObject {
  getBetType() {
    return this.getString('betType');
  }

  setBetType(v) {
    return this.setString('betType', v);
  }

  getTrackKey() {
    return this.getInteger('trackKey');
  }

  setTrackKey(v) {
    return this.setInteger('trackKey', v);
  }

  getDate() {
    return super.getDate('date');
  }

  setDate(v) {
    return super.setDate('date', v);
  }
}
